<template lang="pug">
  div(v-if="hasError")
    p.error(v-for="message in messages") {{ message }}
</template>

<script>
  export default {
    props: ['errors', 'name'],
    computed: {
      hasError () {
        return !!this.messages.length
      },
      messages () {
        if (!this.errors) {
          return []
        }
        const targets = this.errors.filter(error => error.type === this.name)
        const messages = targets.map(t => t.message)
        return Array.prototype.concat.apply([], messages)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/ErrorMessage.vue